import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AutoCompleteService, ReportService } from '../../_services';
import { Observable, Subject } from 'rxjs';
import { Supplier } from '../../_models';
import { debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  searchList : any ={SupAB : String ,ObjectAcc:String,Month :String,Year: String };
  SupplierName :string = "All";
  SupplierAB : Number =0;
  ObjectAccount!: string;
  Month!: String;
  Year!: string;
   results!: Observable<Supplier[]>;  
  private searchTerms = new Subject<string>();  
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>();
   loading: boolean = true;
  lstAccount: any[] = [];
  SelectedAcnt :any ="All";

  constructor(
    private autoCompleteService  : AutoCompleteService,
    private reportService  : ReportService,
    ) { }

  ngOnInit() {
    this.initalCallService();
    this.getObjectAccount();
  }

  initalCallService(){
    
    this.autoCompleteService.endPoint= environment.ApiUrl + "report/getsuplist/term";
    this.results = this.searchTerms.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(_ => (this.loading = true)),
      switchMap(term => this.autoCompleteService.search(term))
    );
    
  }

  // Push a search term into the observable stream.  
  searchSupplier(term: string): void {  
    this.loading = true;  
    this.searchTerms.next(term); 
  }  
   
  onselectSupplier(SupObj :Supplier) {     
    if (SupObj.SupplierAB != 0) {  
      this.SupplierName = SupObj.SupplierName;  
      this.SupplierAB =SupObj.SupplierAB;
      this.loading = false;  
      return true;
    }  
    else {  
      return false;  
    }  
  }
  
  getObjectAccount()
  {
    this.reportService.getObjectAcunt().subscribe(data=>{
      this.lstAccount = data;
    });

  }

  search(){
    this.searchList = {SupAB :this.SupplierAB ,ObjectAcc:this.SelectedAcnt,Month :this.Month,Year:this.Year}
    this.onSearch.emit(this.searchList);
  }
}
